import script from "./UserInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserInfo.vue?vue&type=script&setup=true&lang=ts"

import "./UserInfo.vue?vue&type=style&index=0&id=421f653a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-421f653a"]])

export default __exports__